'use client'

import React, { FC } from 'react'
import styled from 'styled-components'
import { getPublicEnv } from '@tucan/utils'

const Banner = styled.div`
  position: fixed;
  top: 20px;
  left: -60px;
  width: 200px;
  height: 30px;
  transform: rotate(-45deg);
  background: repeating-linear-gradient(
    45deg,
    #EB6435,
    #EB6435 20px,
    #d25a31 20px,
    #d25a31 40px
  );
  text-align: center;
  color: #FFF;
  text-transform: uppercase;
  line-height: 30px;
  font-weight: bold;
  font-size: 12px;
  z-index: 999999999;

  @media (max-width: 900px) {
    height: 20px;
    line-height: 20px;
  }
`

export const EnvironmentInfo: FC = () => {
  if (getPublicEnv('ENVIRONMENT') === 'production') {
    return null
  }

  return (
    <Banner>{getPublicEnv('ENVIRONMENT')}</Banner>
  )
}
